export enum CookieKey {
  AssessmentWrapperId = 'currentAssessmentWrapperId',
  ConfigurationId = 'configurationId',
  CookieConsent = 'rsp_cookie_consent',
  IsLoggedIn = 'isLoggedIn',
  Lang = 'lang',
}
